const ColorWheelData = [
  'RGB(255,0,0)',
  'RGB(255,1,0)',
  'RGB(255,2,0)',
  'RGB(255,3,0)',
  'RGB(255,4,0)',
  'RGB(255,5,0)',
  'RGB(255,6,0)',
  'RGB(255,7,0)',
  'RGB(255,8,0)',
  'RGB(255,9,0)',
  'RGB(255,10,0)',
  'RGB(255,11,0)',
  'RGB(255,12,0)',
  'RGB(255,13,0)',
  'RGB(255,14,0)',
  'RGB(255,15,0)',
  'RGB(255,16,0)',
  'RGB(255,17,0)',
  'RGB(255,18,0)',
  'RGB(255,19,0)',
  'RGB(255,20,0)',
  'RGB(255,21,0)',
  'RGB(255,22,0)',
  'RGB(255,23,0)',
  'RGB(255,24,0)',
  'RGB(255,25,0)',
  'RGB(255,26,0)',
  'RGB(255,27,0)',
  'RGB(255,28,0)',
  'RGB(255,29,0)',
  'RGB(255,30,0)',
  'RGB(255,31,0)',
  'RGB(255,32,0)',
  'RGB(255,33,0)',
  'RGB(255,34,0)',
  'RGB(255,35,0)',
  'RGB(255,36,0)',
  'RGB(255,37,0)',
  'RGB(255,38,0)',
  'RGB(255,39,0)',
  'RGB(255,40,0)',
  'RGB(255,41,0)',
  'RGB(255,42,0)',
  'RGB(255,43,0)',
  'RGB(255,44,0)',
  'RGB(255,45,0)',
  'RGB(255,46,0)',
  'RGB(255,47,0)',
  'RGB(255,48,0)',
  'RGB(255,49,0)',
  'RGB(255,50,0)',
  'RGB(255,51,0)',
  'RGB(255,52,0)',
  'RGB(255,53,0)',
  'RGB(255,54,0)',
  'RGB(255,55,0)',
  'RGB(255,56,0)',
  'RGB(255,57,0)',
  'RGB(255,58,0)',
  'RGB(255,59,0)',
  'RGB(255,60,0)',
  'RGB(255,61,0)',
  'RGB(255,62,0)',
  'RGB(255,63,0)',
  'RGB(255,64,0)',
  'RGB(255,65,0)',
  'RGB(255,66,0)',
  'RGB(255,67,0)',
  'RGB(255,68,0)',
  'RGB(255,69,0)',
  'RGB(255,70,0)',
  'RGB(255,71,0)',
  'RGB(255,72,0)',
  'RGB(255,73,0)',
  'RGB(255,74,0)',
  'RGB(255,75,0)',
  'RGB(255,76,0)',
  'RGB(255,77,0)',
  'RGB(255,78,0)',
  'RGB(255,79,0)',
  'RGB(255,80,0)',
  'RGB(255,81,0)',
  'RGB(255,82,0)',
  'RGB(255,83,0)',
  'RGB(255,84,0)',
  'RGB(255,85,0)',
  'RGB(255,86,0)',
  'RGB(255,87,0)',
  'RGB(255,88,0)',
  'RGB(255,89,0)',
  'RGB(255,90,0)',
  'RGB(255,91,0)',
  'RGB(255,92,0)',
  'RGB(255,93,0)',
  'RGB(255,94,0)',
  'RGB(255,95,0)',
  'RGB(255,96,0)',
  'RGB(255,97,0)',
  'RGB(255,98,0)',
  'RGB(255,99,0)',
  'RGB(255,100,0)',
  'RGB(255,101,0)',
  'RGB(255,102,0)',
  'RGB(255,103,0)',
  'RGB(255,104,0)',
  'RGB(255,105,0)',
  'RGB(255,106,0)',
  'RGB(255,107,0)',
  'RGB(255,108,0)',
  'RGB(255,109,0)',
  'RGB(255,110,0)',
  'RGB(255,111,0)',
  'RGB(255,112,0)',
  'RGB(255,113,0)',
  'RGB(255,114,0)',
  'RGB(255,115,0)',
  'RGB(255,116,0)',
  'RGB(255,117,0)',
  'RGB(255,118,0)',
  'RGB(255,119,0)',
  'RGB(255,120,0)',
  'RGB(255,121,0)',
  'RGB(255,122,0)',
  'RGB(255,123,0)',
  'RGB(255,124,0)',
  'RGB(255,125,0)',
  'RGB(255,126,0)',
  'RGB(255,127,0)',
  'RGB(255,128,0)',
  'RGB(255,129,0)',
  'RGB(255,130,0)',
  'RGB(255,131,0)',
  'RGB(255,132,0)',
  'RGB(255,133,0)',
  'RGB(255,134,0)',
  'RGB(255,135,0)',
  'RGB(255,136,0)',
  'RGB(255,137,0)',
  'RGB(255,138,0)',
  'RGB(255,139,0)',
  'RGB(255,140,0)',
  'RGB(255,141,0)',
  'RGB(255,142,0)',
  'RGB(255,143,0)',
  'RGB(255,144,0)',
  'RGB(255,145,0)',
  'RGB(255,146,0)',
  'RGB(255,147,0)',
  'RGB(255,148,0)',
  'RGB(255,149,0)',
  'RGB(255,150,0)',
  'RGB(255,151,0)',
  'RGB(255,152,0)',
  'RGB(255,153,0)',
  'RGB(255,154,0)',
  'RGB(255,155,0)',
  'RGB(255,156,0)',
  'RGB(255,157,0)',
  'RGB(255,158,0)',
  'RGB(255,159,0)',
  'RGB(255,160,0)',
  'RGB(255,161,0)',
  'RGB(255,162,0)',
  'RGB(255,163,0)',
  'RGB(255,164,0)',
  'RGB(255,165,0)',
  'RGB(255,166,0)',
  'RGB(255,167,0)',
  'RGB(255,168,0)',
  'RGB(255,169,0)',
  'RGB(255,170,0)',
  'RGB(255,171,0)',
  'RGB(255,172,0)',
  'RGB(255,173,0)',
  'RGB(255,174,0)',
  'RGB(255,175,0)',
  'RGB(255,176,0)',
  'RGB(255,177,0)',
  'RGB(255,178,0)',
  'RGB(255,179,0)',
  'RGB(255,180,0)',
  'RGB(255,181,0)',
  'RGB(255,182,0)',
  'RGB(255,183,0)',
  'RGB(255,184,0)',
  'RGB(255,185,0)',
  'RGB(255,186,0)',
  'RGB(255,187,0)',
  'RGB(255,188,0)',
  'RGB(255,189,0)',
  'RGB(255,190,0)',
  'RGB(255,191,0)',
  'RGB(255,192,0)',
  'RGB(255,193,0)',
  'RGB(255,194,0)',
  'RGB(255,195,0)',
  'RGB(255,196,0)',
  'RGB(255,197,0)',
  'RGB(255,198,0)',
  'RGB(255,199,0)',
  'RGB(255,200,0)',
  'RGB(255,201,0)',
  'RGB(255,202,0)',
  'RGB(255,203,0)',
  'RGB(255,204,0)',
  'RGB(255,205,0)',
  'RGB(255,206,0)',
  'RGB(255,207,0)',
  'RGB(255,208,0)',
  'RGB(255,209,0)',
  'RGB(255,210,0)',
  'RGB(255,211,0)',
  'RGB(255,212,0)',
  'RGB(255,213,0)',
  'RGB(255,214,0)',
  'RGB(255,215,0)',
  'RGB(255,216,0)',
  'RGB(255,217,0)',
  'RGB(255,218,0)',
  'RGB(255,219,0)',
  'RGB(255,220,0)',
  'RGB(255,221,0)',
  'RGB(255,222,0)',
  'RGB(255,223,0)',
  'RGB(255,224,0)',
  'RGB(255,225,0)',
  'RGB(255,226,0)',
  'RGB(255,227,0)',
  'RGB(255,228,0)',
  'RGB(255,229,0)',
  'RGB(255,230,0)',
  'RGB(255,231,0)',
  'RGB(255,232,0)',
  'RGB(255,233,0)',
  'RGB(255,234,0)',
  'RGB(255,235,0)',
  'RGB(255,236,0)',
  'RGB(255,237,0)',
  'RGB(255,238,0)',
  'RGB(255,239,0)',
  'RGB(255,240,0)',
  'RGB(255,241,0)',
  'RGB(255,242,0)',
  'RGB(255,243,0)',
  'RGB(255,244,0)',
  'RGB(255,245,0)',
  'RGB(255,246,0)',
  'RGB(255,247,0)',
  'RGB(255,248,0)',
  'RGB(255,249,0)',
  'RGB(255,250,0)',
  'RGB(255,251,0)',
  'RGB(255,252,0)',
  'RGB(255,253,0)',
  'RGB(255,254,0)',
  'RGB(255,255,0)',
  'RGB(254,255,0)',
  'RGB(253,255,0)',
  'RGB(252,255,0)',
  'RGB(251,255,0)',
  'RGB(250,255,0)',
  'RGB(249,255,0)',
  'RGB(248,255,0)',
  'RGB(247,255,0)',
  'RGB(246,255,0)',
  'RGB(245,255,0)',
  'RGB(244,255,0)',
  'RGB(243,255,0)',
  'RGB(242,255,0)',
  'RGB(241,255,0)',
  'RGB(240,255,0)',
  'RGB(239,255,0)',
  'RGB(238,255,0)',
  'RGB(237,255,0)',
  'RGB(236,255,0)',
  'RGB(235,255,0)',
  'RGB(234,255,0)',
  'RGB(233,255,0)',
  'RGB(232,255,0)',
  'RGB(231,255,0)',
  'RGB(230,255,0)',
  'RGB(229,255,0)',
  'RGB(228,255,0)',
  'RGB(227,255,0)',
  'RGB(226,255,0)',
  'RGB(225,255,0)',
  'RGB(224,255,0)',
  'RGB(223,255,0)',
  'RGB(222,255,0)',
  'RGB(221,255,0)',
  'RGB(220,255,0)',
  'RGB(219,255,0)',
  'RGB(218,255,0)',
  'RGB(217,255,0)',
  'RGB(216,255,0)',
  'RGB(215,255,0)',
  'RGB(214,255,0)',
  'RGB(213,255,0)',
  'RGB(212,255,0)',
  'RGB(211,255,0)',
  'RGB(210,255,0)',
  'RGB(209,255,0)',
  'RGB(208,255,0)',
  'RGB(207,255,0)',
  'RGB(206,255,0)',
  'RGB(205,255,0)',
  'RGB(204,255,0)',
  'RGB(203,255,0)',
  'RGB(202,255,0)',
  'RGB(201,255,0)',
  'RGB(200,255,0)',
  'RGB(199,255,0)',
  'RGB(198,255,0)',
  'RGB(197,255,0)',
  'RGB(196,255,0)',
  'RGB(195,255,0)',
  'RGB(194,255,0)',
  'RGB(193,255,0)',
  'RGB(192,255,0)',
  'RGB(191,255,0)',
  'RGB(190,255,0)',
  'RGB(189,255,0)',
  'RGB(188,255,0)',
  'RGB(187,255,0)',
  'RGB(186,255,0)',
  'RGB(185,255,0)',
  'RGB(184,255,0)',
  'RGB(183,255,0)',
  'RGB(182,255,0)',
  'RGB(181,255,0)',
  'RGB(180,255,0)',
  'RGB(179,255,0)',
  'RGB(178,255,0)',
  'RGB(177,255,0)',
  'RGB(176,255,0)',
  'RGB(175,255,0)',
  'RGB(174,255,0)',
  'RGB(173,255,0)',
  'RGB(172,255,0)',
  'RGB(171,255,0)',
  'RGB(170,255,0)',
  'RGB(169,255,0)',
  'RGB(168,255,0)',
  'RGB(167,255,0)',
  'RGB(166,255,0)',
  'RGB(165,255,0)',
  'RGB(164,255,0)',
  'RGB(163,255,0)',
  'RGB(162,255,0)',
  'RGB(161,255,0)',
  'RGB(160,255,0)',
  'RGB(159,255,0)',
  'RGB(158,255,0)',
  'RGB(157,255,0)',
  'RGB(156,255,0)',
  'RGB(155,255,0)',
  'RGB(154,255,0)',
  'RGB(153,255,0)',
  'RGB(152,255,0)',
  'RGB(151,255,0)',
  'RGB(150,255,0)',
  'RGB(149,255,0)',
  'RGB(148,255,0)',
  'RGB(147,255,0)',
  'RGB(146,255,0)',
  'RGB(145,255,0)',
  'RGB(144,255,0)',
  'RGB(143,255,0)',
  'RGB(142,255,0)',
  'RGB(141,255,0)',
  'RGB(140,255,0)',
  'RGB(139,255,0)',
  'RGB(138,255,0)',
  'RGB(137,255,0)',
  'RGB(136,255,0)',
  'RGB(135,255,0)',
  'RGB(134,255,0)',
  'RGB(133,255,0)',
  'RGB(132,255,0)',
  'RGB(131,255,0)',
  'RGB(130,255,0)',
  'RGB(129,255,0)',
  'RGB(128,255,0)',
  'RGB(127,255,0)',
  'RGB(126,255,0)',
  'RGB(125,255,0)',
  'RGB(124,255,0)',
  'RGB(123,255,0)',
  'RGB(122,255,0)',
  'RGB(121,255,0)',
  'RGB(120,255,0)',
  'RGB(119,255,0)',
  'RGB(118,255,0)',
  'RGB(117,255,0)',
  'RGB(116,255,0)',
  'RGB(115,255,0)',
  'RGB(114,255,0)',
  'RGB(113,255,0)',
  'RGB(112,255,0)',
  'RGB(111,255,0)',
  'RGB(110,255,0)',
  'RGB(109,255,0)',
  'RGB(108,255,0)',
  'RGB(107,255,0)',
  'RGB(106,255,0)',
  'RGB(105,255,0)',
  'RGB(104,255,0)',
  'RGB(103,255,0)',
  'RGB(102,255,0)',
  'RGB(101,255,0)',
  'RGB(100,255,0)',
  'RGB(99,255,0)',
  'RGB(98,255,0)',
  'RGB(97,255,0)',
  'RGB(96,255,0)',
  'RGB(95,255,0)',
  'RGB(94,255,0)',
  'RGB(93,255,0)',
  'RGB(92,255,0)',
  'RGB(91,255,0)',
  'RGB(90,255,0)',
  'RGB(89,255,0)',
  'RGB(88,255,0)',
  'RGB(87,255,0)',
  'RGB(86,255,0)',
  'RGB(85,255,0)',
  'RGB(84,255,0)',
  'RGB(83,255,0)',
  'RGB(82,255,0)',
  'RGB(81,255,0)',
  'RGB(80,255,0)',
  'RGB(79,255,0)',
  'RGB(78,255,0)',
  'RGB(77,255,0)',
  'RGB(76,255,0)',
  'RGB(75,255,0)',
  'RGB(74,255,0)',
  'RGB(73,255,0)',
  'RGB(72,255,0)',
  'RGB(71,255,0)',
  'RGB(70,255,0)',
  'RGB(69,255,0)',
  'RGB(68,255,0)',
  'RGB(67,255,0)',
  'RGB(66,255,0)',
  'RGB(65,255,0)',
  'RGB(64,255,0)',
  'RGB(63,255,0)',
  'RGB(62,255,0)',
  'RGB(61,255,0)',
  'RGB(60,255,0)',
  'RGB(59,255,0)',
  'RGB(58,255,0)',
  'RGB(57,255,0)',
  'RGB(56,255,0)',
  'RGB(55,255,0)',
  'RGB(54,255,0)',
  'RGB(53,255,0)',
  'RGB(52,255,0)',
  'RGB(51,255,0)',
  'RGB(50,255,0)',
  'RGB(49,255,0)',
  'RGB(48,255,0)',
  'RGB(47,255,0)',
  'RGB(46,255,0)',
  'RGB(45,255,0)',
  'RGB(44,255,0)',
  'RGB(43,255,0)',
  'RGB(42,255,0)',
  'RGB(41,255,0)',
  'RGB(40,255,0)',
  'RGB(39,255,0)',
  'RGB(38,255,0)',
  'RGB(37,255,0)',
  'RGB(36,255,0)',
  'RGB(35,255,0)',
  'RGB(34,255,0)',
  'RGB(33,255,0)',
  'RGB(32,255,0)',
  'RGB(31,255,0)',
  'RGB(30,255,0)',
  'RGB(29,255,0)',
  'RGB(28,255,0)',
  'RGB(27,255,0)',
  'RGB(26,255,0)',
  'RGB(25,255,0)',
  'RGB(24,255,0)',
  'RGB(23,255,0)',
  'RGB(22,255,0)',
  'RGB(21,255,0)',
  'RGB(20,255,0)',
  'RGB(19,255,0)',
  'RGB(18,255,0)',
  'RGB(17,255,0)',
  'RGB(16,255,0)',
  'RGB(15,255,0)',
  'RGB(14,255,0)',
  'RGB(13,255,0)',
  'RGB(12,255,0)',
  'RGB(11,255,0)',
  'RGB(10,255,0)',
  'RGB(9,255,0)',
  'RGB(8,255,0)',
  'RGB(7,255,0)',
  'RGB(6,255,0)',
  'RGB(5,255,0)',
  'RGB(4,255,0)',
  'RGB(3,255,0)',
  'RGB(2,255,0)',
  'RGB(1,255,0)',
  'RGB(0,255,0)',
  'RGB(0,255,1)',
  'RGB(0,255,2)',
  'RGB(0,255,3)',
  'RGB(0,255,4)',
  'RGB(0,255,5)',
  'RGB(0,255,6)',
  'RGB(0,255,7)',
  'RGB(0,255,8)',
  'RGB(0,255,9)',
  'RGB(0,255,10)',
  'RGB(0,255,11)',
  'RGB(0,255,12)',
  'RGB(0,255,13)',
  'RGB(0,255,14)',
  'RGB(0,255,15)',
  'RGB(0,255,16)',
  'RGB(0,255,17)',
  'RGB(0,255,18)',
  'RGB(0,255,19)',
  'RGB(0,255,20)',
  'RGB(0,255,21)',
  'RGB(0,255,22)',
  'RGB(0,255,23)',
  'RGB(0,255,24)',
  'RGB(0,255,25)',
  'RGB(0,255,26)',
  'RGB(0,255,27)',
  'RGB(0,255,28)',
  'RGB(0,255,29)',
  'RGB(0,255,30)',
  'RGB(0,255,31)',
  'RGB(0,255,32)',
  'RGB(0,255,33)',
  'RGB(0,255,34)',
  'RGB(0,255,35)',
  'RGB(0,255,36)',
  'RGB(0,255,37)',
  'RGB(0,255,38)',
  'RGB(0,255,39)',
  'RGB(0,255,40)',
  'RGB(0,255,41)',
  'RGB(0,255,42)',
  'RGB(0,255,43)',
  'RGB(0,255,44)',
  'RGB(0,255,45)',
  'RGB(0,255,46)',
  'RGB(0,255,47)',
  'RGB(0,255,48)',
  'RGB(0,255,49)',
  'RGB(0,255,50)',
  'RGB(0,255,51)',
  'RGB(0,255,52)',
  'RGB(0,255,53)',
  'RGB(0,255,54)',
  'RGB(0,255,55)',
  'RGB(0,255,56)',
  'RGB(0,255,57)',
  'RGB(0,255,58)',
  'RGB(0,255,59)',
  'RGB(0,255,60)',
  'RGB(0,255,61)',
  'RGB(0,255,62)',
  'RGB(0,255,63)',
  'RGB(0,255,64)',
  'RGB(0,255,65)',
  'RGB(0,255,66)',
  'RGB(0,255,67)',
  'RGB(0,255,68)',
  'RGB(0,255,69)',
  'RGB(0,255,70)',
  'RGB(0,255,71)',
  'RGB(0,255,72)',
  'RGB(0,255,73)',
  'RGB(0,255,74)',
  'RGB(0,255,75)',
  'RGB(0,255,76)',
  'RGB(0,255,77)',
  'RGB(0,255,78)',
  'RGB(0,255,79)',
  'RGB(0,255,80)',
  'RGB(0,255,81)',
  'RGB(0,255,82)',
  'RGB(0,255,83)',
  'RGB(0,255,84)',
  'RGB(0,255,85)',
  'RGB(0,255,86)',
  'RGB(0,255,87)',
  'RGB(0,255,88)',
  'RGB(0,255,89)',
  'RGB(0,255,90)',
  'RGB(0,255,91)',
  'RGB(0,255,92)',
  'RGB(0,255,93)',
  'RGB(0,255,94)',
  'RGB(0,255,95)',
  'RGB(0,255,96)',
  'RGB(0,255,97)',
  'RGB(0,255,98)',
  'RGB(0,255,99)',
  'RGB(0,255,100)',
  'RGB(0,255,101)',
  'RGB(0,255,102)',
  'RGB(0,255,103)',
  'RGB(0,255,104)',
  'RGB(0,255,105)',
  'RGB(0,255,106)',
  'RGB(0,255,107)',
  'RGB(0,255,108)',
  'RGB(0,255,109)',
  'RGB(0,255,110)',
  'RGB(0,255,111)',
  'RGB(0,255,112)',
  'RGB(0,255,113)',
  'RGB(0,255,114)',
  'RGB(0,255,115)',
  'RGB(0,255,116)',
  'RGB(0,255,117)',
  'RGB(0,255,118)',
  'RGB(0,255,119)',
  'RGB(0,255,120)',
  'RGB(0,255,121)',
  'RGB(0,255,122)',
  'RGB(0,255,123)',
  'RGB(0,255,124)',
  'RGB(0,255,125)',
  'RGB(0,255,126)',
  'RGB(0,255,127)',
  'RGB(0,255,128)',
  'RGB(0,255,129)',
  'RGB(0,255,130)',
  'RGB(0,255,131)',
  'RGB(0,255,132)',
  'RGB(0,255,133)',
  'RGB(0,255,134)',
  'RGB(0,255,135)',
  'RGB(0,255,136)',
  'RGB(0,255,137)',
  'RGB(0,255,138)',
  'RGB(0,255,139)',
  'RGB(0,255,140)',
  'RGB(0,255,141)',
  'RGB(0,255,142)',
  'RGB(0,255,143)',
  'RGB(0,255,144)',
  'RGB(0,255,145)',
  'RGB(0,255,146)',
  'RGB(0,255,147)',
  'RGB(0,255,148)',
  'RGB(0,255,149)',
  'RGB(0,255,150)',
  'RGB(0,255,151)',
  'RGB(0,255,152)',
  'RGB(0,255,153)',
  'RGB(0,255,154)',
  'RGB(0,255,155)',
  'RGB(0,255,156)',
  'RGB(0,255,157)',
  'RGB(0,255,158)',
  'RGB(0,255,159)',
  'RGB(0,255,160)',
  'RGB(0,255,161)',
  'RGB(0,255,162)',
  'RGB(0,255,163)',
  'RGB(0,255,164)',
  'RGB(0,255,165)',
  'RGB(0,255,166)',
  'RGB(0,255,167)',
  'RGB(0,255,168)',
  'RGB(0,255,169)',
  'RGB(0,255,170)',
  'RGB(0,255,171)',
  'RGB(0,255,172)',
  'RGB(0,255,173)',
  'RGB(0,255,174)',
  'RGB(0,255,175)',
  'RGB(0,255,176)',
  'RGB(0,255,177)',
  'RGB(0,255,178)',
  'RGB(0,255,179)',
  'RGB(0,255,180)',
  'RGB(0,255,181)',
  'RGB(0,255,182)',
  'RGB(0,255,183)',
  'RGB(0,255,184)',
  'RGB(0,255,185)',
  'RGB(0,255,186)',
  'RGB(0,255,187)',
  'RGB(0,255,188)',
  'RGB(0,255,189)',
  'RGB(0,255,190)',
  'RGB(0,255,191)',
  'RGB(0,255,192)',
  'RGB(0,255,193)',
  'RGB(0,255,194)',
  'RGB(0,255,195)',
  'RGB(0,255,196)',
  'RGB(0,255,197)',
  'RGB(0,255,198)',
  'RGB(0,255,199)',
  'RGB(0,255,200)',
  'RGB(0,255,201)',
  'RGB(0,255,202)',
  'RGB(0,255,203)',
  'RGB(0,255,204)',
  'RGB(0,255,205)',
  'RGB(0,255,206)',
  'RGB(0,255,207)',
  'RGB(0,255,208)',
  'RGB(0,255,209)',
  'RGB(0,255,210)',
  'RGB(0,255,211)',
  'RGB(0,255,212)',
  'RGB(0,255,213)',
  'RGB(0,255,214)',
  'RGB(0,255,215)',
  'RGB(0,255,216)',
  'RGB(0,255,217)',
  'RGB(0,255,218)',
  'RGB(0,255,219)',
  'RGB(0,255,220)',
  'RGB(0,255,221)',
  'RGB(0,255,222)',
  'RGB(0,255,223)',
  'RGB(0,255,224)',
  'RGB(0,255,225)',
  'RGB(0,255,226)',
  'RGB(0,255,227)',
  'RGB(0,255,228)',
  'RGB(0,255,229)',
  'RGB(0,255,230)',
  'RGB(0,255,231)',
  'RGB(0,255,232)',
  'RGB(0,255,233)',
  'RGB(0,255,234)',
  'RGB(0,255,235)',
  'RGB(0,255,236)',
  'RGB(0,255,237)',
  'RGB(0,255,238)',
  'RGB(0,255,239)',
  'RGB(0,255,240)',
  'RGB(0,255,241)',
  'RGB(0,255,242)',
  'RGB(0,255,243)',
  'RGB(0,255,244)',
  'RGB(0,255,245)',
  'RGB(0,255,246)',
  'RGB(0,255,247)',
  'RGB(0,255,248)',
  'RGB(0,255,249)',
  'RGB(0,255,250)',
  'RGB(0,255,251)',
  'RGB(0,255,252)',
  'RGB(0,255,253)',
  'RGB(0,255,254)',
  'RGB(0,255,255)',
  'RGB(0,254,255)',
  'RGB(0,253,255)',
  'RGB(0,252,255)',
  'RGB(0,251,255)',
  'RGB(0,250,255)',
  'RGB(0,249,255)',
  'RGB(0,248,255)',
  'RGB(0,247,255)',
  'RGB(0,246,255)',
  'RGB(0,245,255)',
  'RGB(0,244,255)',
  'RGB(0,243,255)',
  'RGB(0,242,255)',
  'RGB(0,241,255)',
  'RGB(0,240,255)',
  'RGB(0,239,255)',
  'RGB(0,238,255)',
  'RGB(0,237,255)',
  'RGB(0,236,255)',
  'RGB(0,235,255)',
  'RGB(0,234,255)',
  'RGB(0,233,255)',
  'RGB(0,232,255)',
  'RGB(0,231,255)',
  'RGB(0,230,255)',
  'RGB(0,229,255)',
  'RGB(0,228,255)',
  'RGB(0,227,255)',
  'RGB(0,226,255)',
  'RGB(0,225,255)',
  'RGB(0,224,255)',
  'RGB(0,223,255)',
  'RGB(0,222,255)',
  'RGB(0,221,255)',
  'RGB(0,220,255)',
  'RGB(0,219,255)',
  'RGB(0,218,255)',
  'RGB(0,217,255)',
  'RGB(0,216,255)',
  'RGB(0,215,255)',
  'RGB(0,214,255)',
  'RGB(0,213,255)',
  'RGB(0,212,255)',
  'RGB(0,211,255)',
  'RGB(0,210,255)',
  'RGB(0,209,255)',
  'RGB(0,208,255)',
  'RGB(0,207,255)',
  'RGB(0,206,255)',
  'RGB(0,205,255)',
  'RGB(0,204,255)',
  'RGB(0,203,255)',
  'RGB(0,202,255)',
  'RGB(0,201,255)',
  'RGB(0,200,255)',
  'RGB(0,199,255)',
  'RGB(0,198,255)',
  'RGB(0,197,255)',
  'RGB(0,196,255)',
  'RGB(0,195,255)',
  'RGB(0,194,255)',
  'RGB(0,193,255)',
  'RGB(0,192,255)',
  'RGB(0,191,255)',
  'RGB(0,190,255)',
  'RGB(0,189,255)',
  'RGB(0,188,255)',
  'RGB(0,187,255)',
  'RGB(0,186,255)',
  'RGB(0,185,255)',
  'RGB(0,184,255)',
  'RGB(0,183,255)',
  'RGB(0,182,255)',
  'RGB(0,181,255)',
  'RGB(0,180,255)',
  'RGB(0,179,255)',
  'RGB(0,178,255)',
  'RGB(0,177,255)',
  'RGB(0,176,255)',
  'RGB(0,175,255)',
  'RGB(0,174,255)',
  'RGB(0,173,255)',
  'RGB(0,172,255)',
  'RGB(0,171,255)',
  'RGB(0,170,255)',
  'RGB(0,169,255)',
  'RGB(0,168,255)',
  'RGB(0,167,255)',
  'RGB(0,166,255)',
  'RGB(0,165,255)',
  'RGB(0,164,255)',
  'RGB(0,163,255)',
  'RGB(0,162,255)',
  'RGB(0,161,255)',
  'RGB(0,160,255)',
  'RGB(0,159,255)',
  'RGB(0,158,255)',
  'RGB(0,157,255)',
  'RGB(0,156,255)',
  'RGB(0,155,255)',
  'RGB(0,154,255)',
  'RGB(0,153,255)',
  'RGB(0,152,255)',
  'RGB(0,151,255)',
  'RGB(0,150,255)',
  'RGB(0,149,255)',
  'RGB(0,148,255)',
  'RGB(0,147,255)',
  'RGB(0,146,255)',
  'RGB(0,145,255)',
  'RGB(0,144,255)',
  'RGB(0,143,255)',
  'RGB(0,142,255)',
  'RGB(0,141,255)',
  'RGB(0,140,255)',
  'RGB(0,139,255)',
  'RGB(0,138,255)',
  'RGB(0,137,255)',
  'RGB(0,136,255)',
  'RGB(0,135,255)',
  'RGB(0,134,255)',
  'RGB(0,133,255)',
  'RGB(0,132,255)',
  'RGB(0,131,255)',
  'RGB(0,130,255)',
  'RGB(0,129,255)',
  'RGB(0,128,255)',
  'RGB(0,127,255)',
  'RGB(0,126,255)',
  'RGB(0,125,255)',
  'RGB(0,124,255)',
  'RGB(0,123,255)',
  'RGB(0,122,255)',
  'RGB(0,121,255)',
  'RGB(0,120,255)',
  'RGB(0,119,255)',
  'RGB(0,118,255)',
  'RGB(0,117,255)',
  'RGB(0,116,255)',
  'RGB(0,115,255)',
  'RGB(0,114,255)',
  'RGB(0,113,255)',
  'RGB(0,112,255)',
  'RGB(0,111,255)',
  'RGB(0,110,255)',
  'RGB(0,109,255)',
  'RGB(0,108,255)',
  'RGB(0,107,255)',
  'RGB(0,106,255)',
  'RGB(0,105,255)',
  'RGB(0,104,255)',
  'RGB(0,103,255)',
  'RGB(0,102,255)',
  'RGB(0,101,255)',
  'RGB(0,100,255)',
  'RGB(0,99,255)',
  'RGB(0,98,255)',
  'RGB(0,97,255)',
  'RGB(0,96,255)',
  'RGB(0,95,255)',
  'RGB(0,94,255)',
  'RGB(0,93,255)',
  'RGB(0,92,255)',
  'RGB(0,91,255)',
  'RGB(0,90,255)',
  'RGB(0,89,255)',
  'RGB(0,88,255)',
  'RGB(0,87,255)',
  'RGB(0,86,255)',
  'RGB(0,85,255)',
  'RGB(0,84,255)',
  'RGB(0,83,255)',
  'RGB(0,82,255)',
  'RGB(0,81,255)',
  'RGB(0,80,255)',
  'RGB(0,79,255)',
  'RGB(0,78,255)',
  'RGB(0,77,255)',
  'RGB(0,76,255)',
  'RGB(0,75,255)',
  'RGB(0,74,255)',
  'RGB(0,73,255)',
  'RGB(0,72,255)',
  'RGB(0,71,255)',
  'RGB(0,70,255)',
  'RGB(0,69,255)',
  'RGB(0,68,255)',
  'RGB(0,67,255)',
  'RGB(0,66,255)',
  'RGB(0,65,255)',
  'RGB(0,64,255)',
  'RGB(0,63,255)',
  'RGB(0,62,255)',
  'RGB(0,61,255)',
  'RGB(0,60,255)',
  'RGB(0,59,255)',
  'RGB(0,58,255)',
  'RGB(0,57,255)',
  'RGB(0,56,255)',
  'RGB(0,55,255)',
  'RGB(0,54,255)',
  'RGB(0,53,255)',
  'RGB(0,52,255)',
  'RGB(0,51,255)',
  'RGB(0,50,255)',
  'RGB(0,49,255)',
  'RGB(0,48,255)',
  'RGB(0,47,255)',
  'RGB(0,46,255)',
  'RGB(0,45,255)',
  'RGB(0,44,255)',
  'RGB(0,43,255)',
  'RGB(0,42,255)',
  'RGB(0,41,255)',
  'RGB(0,40,255)',
  'RGB(0,39,255)',
  'RGB(0,38,255)',
  'RGB(0,37,255)',
  'RGB(0,36,255)',
  'RGB(0,35,255)',
  'RGB(0,34,255)',
  'RGB(0,33,255)',
  'RGB(0,32,255)',
  'RGB(0,31,255)',
  'RGB(0,30,255)',
  'RGB(0,29,255)',
  'RGB(0,28,255)',
  'RGB(0,27,255)',
  'RGB(0,26,255)',
  'RGB(0,25,255)',
  'RGB(0,24,255)',
  'RGB(0,23,255)',
  'RGB(0,22,255)',
  'RGB(0,21,255)',
  'RGB(0,20,255)',
  'RGB(0,19,255)',
  'RGB(0,18,255)',
  'RGB(0,17,255)',
  'RGB(0,16,255)',
  'RGB(0,15,255)',
  'RGB(0,14,255)',
  'RGB(0,13,255)',
  'RGB(0,12,255)',
  'RGB(0,11,255)',
  'RGB(0,10,255)',
  'RGB(0,9,255)',
  'RGB(0,8,255)',
  'RGB(0,7,255)',
  'RGB(0,6,255)',
  'RGB(0,5,255)',
  'RGB(0,4,255)',
  'RGB(0,3,255)',
  'RGB(0,2,255)',
  'RGB(0,1,255)',
  'RGB(0,0,255)',
  'RGB(1,0,255)',
  'RGB(2,0,255)',
  'RGB(3,0,255)',
  'RGB(4,0,255)',
  'RGB(5,0,255)',
  'RGB(6,0,255)',
  'RGB(7,0,255)',
  'RGB(8,0,255)',
  'RGB(9,0,255)',
  'RGB(10,0,255)',
  'RGB(11,0,255)',
  'RGB(12,0,255)',
  'RGB(13,0,255)',
  'RGB(14,0,255)',
  'RGB(15,0,255)',
  'RGB(16,0,255)',
  'RGB(17,0,255)',
  'RGB(18,0,255)',
  'RGB(19,0,255)',
  'RGB(20,0,255)',
  'RGB(21,0,255)',
  'RGB(22,0,255)',
  'RGB(23,0,255)',
  'RGB(24,0,255)',
  'RGB(25,0,255)',
  'RGB(26,0,255)',
  'RGB(27,0,255)',
  'RGB(28,0,255)',
  'RGB(29,0,255)',
  'RGB(30,0,255)',
  'RGB(31,0,255)',
  'RGB(32,0,255)',
  'RGB(33,0,255)',
  'RGB(34,0,255)',
  'RGB(35,0,255)',
  'RGB(36,0,255)',
  'RGB(37,0,255)',
  'RGB(38,0,255)',
  'RGB(39,0,255)',
  'RGB(40,0,255)',
  'RGB(41,0,255)',
  'RGB(42,0,255)',
  'RGB(43,0,255)',
  'RGB(44,0,255)',
  'RGB(45,0,255)',
  'RGB(46,0,255)',
  'RGB(47,0,255)',
  'RGB(48,0,255)',
  'RGB(49,0,255)',
  'RGB(50,0,255)',
  'RGB(51,0,255)',
  'RGB(52,0,255)',
  'RGB(53,0,255)',
  'RGB(54,0,255)',
  'RGB(55,0,255)',
  'RGB(56,0,255)',
  'RGB(57,0,255)',
  'RGB(58,0,255)',
  'RGB(59,0,255)',
  'RGB(60,0,255)',
  'RGB(61,0,255)',
  'RGB(62,0,255)',
  'RGB(63,0,255)',
  'RGB(64,0,255)',
  'RGB(65,0,255)',
  'RGB(66,0,255)',
  'RGB(67,0,255)',
  'RGB(68,0,255)',
  'RGB(69,0,255)',
  'RGB(70,0,255)',
  'RGB(71,0,255)',
  'RGB(72,0,255)',
  'RGB(73,0,255)',
  'RGB(74,0,255)',
  'RGB(75,0,255)',
  'RGB(76,0,255)',
  'RGB(77,0,255)',
  'RGB(78,0,255)',
  'RGB(79,0,255)',
  'RGB(80,0,255)',
  'RGB(81,0,255)',
  'RGB(82,0,255)',
  'RGB(83,0,255)',
  'RGB(84,0,255)',
  'RGB(85,0,255)',
  'RGB(86,0,255)',
  'RGB(87,0,255)',
  'RGB(88,0,255)',
  'RGB(89,0,255)',
  'RGB(90,0,255)',
  'RGB(91,0,255)',
  'RGB(92,0,255)',
  'RGB(93,0,255)',
  'RGB(94,0,255)',
  'RGB(95,0,255)',
  'RGB(96,0,255)',
  'RGB(97,0,255)',
  'RGB(98,0,255)',
  'RGB(99,0,255)',
  'RGB(100,0,255)',
  'RGB(101,0,255)',
  'RGB(102,0,255)',
  'RGB(103,0,255)',
  'RGB(104,0,255)',
  'RGB(105,0,255)',
  'RGB(106,0,255)',
  'RGB(107,0,255)',
  'RGB(108,0,255)',
  'RGB(109,0,255)',
  'RGB(110,0,255)',
  'RGB(111,0,255)',
  'RGB(112,0,255)',
  'RGB(113,0,255)',
  'RGB(114,0,255)',
  'RGB(115,0,255)',
  'RGB(116,0,255)',
  'RGB(117,0,255)',
  'RGB(118,0,255)',
  'RGB(119,0,255)',
  'RGB(120,0,255)',
  'RGB(121,0,255)',
  'RGB(122,0,255)',
  'RGB(123,0,255)',
  'RGB(124,0,255)',
  'RGB(125,0,255)',
  'RGB(126,0,255)',
  'RGB(127,0,255)',
  'RGB(128,0,255)',
  'RGB(129,0,255)',
  'RGB(130,0,255)',
  'RGB(131,0,255)',
  'RGB(132,0,255)',
  'RGB(133,0,255)',
  'RGB(134,0,255)',
  'RGB(135,0,255)',
  'RGB(136,0,255)',
  'RGB(137,0,255)',
  'RGB(138,0,255)',
  'RGB(139,0,255)',
  'RGB(140,0,255)',
  'RGB(141,0,255)',
  'RGB(142,0,255)',
  'RGB(143,0,255)',
  'RGB(144,0,255)',
  'RGB(145,0,255)',
  'RGB(146,0,255)',
  'RGB(147,0,255)',
  'RGB(148,0,255)',
  'RGB(149,0,255)',
  'RGB(150,0,255)',
  'RGB(151,0,255)',
  'RGB(152,0,255)',
  'RGB(153,0,255)',
  'RGB(154,0,255)',
  'RGB(155,0,255)',
  'RGB(156,0,255)',
  'RGB(157,0,255)',
  'RGB(158,0,255)',
  'RGB(159,0,255)',
  'RGB(160,0,255)',
  'RGB(161,0,255)',
  'RGB(162,0,255)',
  'RGB(163,0,255)',
  'RGB(164,0,255)',
  'RGB(165,0,255)',
  'RGB(166,0,255)',
  'RGB(167,0,255)',
  'RGB(168,0,255)',
  'RGB(169,0,255)',
  'RGB(170,0,255)',
  'RGB(171,0,255)',
  'RGB(172,0,255)',
  'RGB(173,0,255)',
  'RGB(174,0,255)',
  'RGB(175,0,255)',
  'RGB(176,0,255)',
  'RGB(177,0,255)',
  'RGB(178,0,255)',
  'RGB(179,0,255)',
  'RGB(180,0,255)',
  'RGB(181,0,255)',
  'RGB(182,0,255)',
  'RGB(183,0,255)',
  'RGB(184,0,255)',
  'RGB(185,0,255)',
  'RGB(186,0,255)',
  'RGB(187,0,255)',
  'RGB(188,0,255)',
  'RGB(189,0,255)',
  'RGB(190,0,255)',
  'RGB(191,0,255)',
  'RGB(192,0,255)',
  'RGB(193,0,255)',
  'RGB(194,0,255)',
  'RGB(195,0,255)',
  'RGB(196,0,255)',
  'RGB(197,0,255)',
  'RGB(198,0,255)',
  'RGB(199,0,255)',
  'RGB(200,0,255)',
  'RGB(201,0,255)',
  'RGB(202,0,255)',
  'RGB(203,0,255)',
  'RGB(204,0,255)',
  'RGB(205,0,255)',
  'RGB(206,0,255)',
  'RGB(207,0,255)',
  'RGB(208,0,255)',
  'RGB(209,0,255)',
  'RGB(210,0,255)',
  'RGB(211,0,255)',
  'RGB(212,0,255)',
  'RGB(213,0,255)',
  'RGB(214,0,255)',
  'RGB(215,0,255)',
  'RGB(216,0,255)',
  'RGB(217,0,255)',
  'RGB(218,0,255)',
  'RGB(219,0,255)',
  'RGB(220,0,255)',
  'RGB(221,0,255)',
  'RGB(222,0,255)',
  'RGB(223,0,255)',
  'RGB(224,0,255)',
  'RGB(225,0,255)',
  'RGB(226,0,255)',
  'RGB(227,0,255)',
  'RGB(228,0,255)',
  'RGB(229,0,255)',
  'RGB(230,0,255)',
  'RGB(231,0,255)',
  'RGB(232,0,255)',
  'RGB(233,0,255)',
  'RGB(234,0,255)',
  'RGB(235,0,255)',
  'RGB(236,0,255)',
  'RGB(237,0,255)',
  'RGB(238,0,255)',
  'RGB(239,0,255)',
  'RGB(240,0,255)',
  'RGB(241,0,255)',
  'RGB(242,0,255)',
  'RGB(243,0,255)',
  'RGB(244,0,255)',
  'RGB(245,0,255)',
  'RGB(246,0,255)',
  'RGB(247,0,255)',
  'RGB(248,0,255)',
  'RGB(249,0,255)',
  'RGB(250,0,255)',
  'RGB(251,0,255)',
  'RGB(252,0,255)',
  'RGB(253,0,255)',
  'RGB(254,0,255)',
  'RGB(255,0,255)',
  'RGB(255,0,254)',
  'RGB(255,0,253)',
  'RGB(255,0,252)',
  'RGB(255,0,251)',
  'RGB(255,0,250)',
  'RGB(255,0,249)',
  'RGB(255,0,248)',
  'RGB(255,0,247)',
  'RGB(255,0,246)',
  'RGB(255,0,245)',
  'RGB(255,0,244)',
  'RGB(255,0,243)',
  'RGB(255,0,242)',
  'RGB(255,0,241)',
  'RGB(255,0,240)',
  'RGB(255,0,239)',
  'RGB(255,0,238)',
  'RGB(255,0,237)',
  'RGB(255,0,236)',
  'RGB(255,0,235)',
  'RGB(255,0,234)',
  'RGB(255,0,233)',
  'RGB(255,0,232)',
  'RGB(255,0,231)',
  'RGB(255,0,230)',
  'RGB(255,0,229)',
  'RGB(255,0,228)',
  'RGB(255,0,227)',
  'RGB(255,0,226)',
  'RGB(255,0,225)',
  'RGB(255,0,224)',
  'RGB(255,0,223)',
  'RGB(255,0,222)',
  'RGB(255,0,221)',
  'RGB(255,0,220)',
  'RGB(255,0,219)',
  'RGB(255,0,218)',
  'RGB(255,0,217)',
  'RGB(255,0,216)',
  'RGB(255,0,215)',
  'RGB(255,0,214)',
  'RGB(255,0,213)',
  'RGB(255,0,212)',
  'RGB(255,0,211)',
  'RGB(255,0,210)',
  'RGB(255,0,209)',
  'RGB(255,0,208)',
  'RGB(255,0,207)',
  'RGB(255,0,206)',
  'RGB(255,0,205)',
  'RGB(255,0,204)',
  'RGB(255,0,203)',
  'RGB(255,0,202)',
  'RGB(255,0,201)',
  'RGB(255,0,200)',
  'RGB(255,0,199)',
  'RGB(255,0,198)',
  'RGB(255,0,197)',
  'RGB(255,0,196)',
  'RGB(255,0,195)',
  'RGB(255,0,194)',
  'RGB(255,0,193)',
  'RGB(255,0,192)',
  'RGB(255,0,191)',
  'RGB(255,0,190)',
  'RGB(255,0,189)',
  'RGB(255,0,188)',
  'RGB(255,0,187)',
  'RGB(255,0,186)',
  'RGB(255,0,185)',
  'RGB(255,0,184)',
  'RGB(255,0,183)',
  'RGB(255,0,182)',
  'RGB(255,0,181)',
  'RGB(255,0,180)',
  'RGB(255,0,179)',
  'RGB(255,0,178)',
  'RGB(255,0,177)',
  'RGB(255,0,176)',
  'RGB(255,0,175)',
  'RGB(255,0,174)',
  'RGB(255,0,173)',
  'RGB(255,0,172)',
  'RGB(255,0,171)',
  'RGB(255,0,170)',
  'RGB(255,0,169)',
  'RGB(255,0,168)',
  'RGB(255,0,167)',
  'RGB(255,0,166)',
  'RGB(255,0,165)',
  'RGB(255,0,164)',
  'RGB(255,0,163)',
  'RGB(255,0,162)',
  'RGB(255,0,161)',
  'RGB(255,0,160)',
  'RGB(255,0,159)',
  'RGB(255,0,158)',
  'RGB(255,0,157)',
  'RGB(255,0,156)',
  'RGB(255,0,155)',
  'RGB(255,0,154)',
  'RGB(255,0,153)',
  'RGB(255,0,152)',
  'RGB(255,0,151)',
  'RGB(255,0,150)',
  'RGB(255,0,149)',
  'RGB(255,0,148)',
  'RGB(255,0,147)',
  'RGB(255,0,146)',
  'RGB(255,0,145)',
  'RGB(255,0,144)',
  'RGB(255,0,143)',
  'RGB(255,0,142)',
  'RGB(255,0,141)',
  'RGB(255,0,140)',
  'RGB(255,0,139)',
  'RGB(255,0,138)',
  'RGB(255,0,137)',
  'RGB(255,0,136)',
  'RGB(255,0,135)',
  'RGB(255,0,134)',
  'RGB(255,0,133)',
  'RGB(255,0,132)',
  'RGB(255,0,131)',
  'RGB(255,0,130)',
  'RGB(255,0,129)',
  'RGB(255,0,128)',
  'RGB(255,0,127)',
  'RGB(255,0,126)',
  'RGB(255,0,125)',
  'RGB(255,0,124)',
  'RGB(255,0,123)',
  'RGB(255,0,122)',
  'RGB(255,0,121)',
  'RGB(255,0,120)',
  'RGB(255,0,119)',
  'RGB(255,0,118)',
  'RGB(255,0,117)',
  'RGB(255,0,116)',
  'RGB(255,0,115)',
  'RGB(255,0,114)',
  'RGB(255,0,113)',
  'RGB(255,0,112)',
  'RGB(255,0,111)',
  'RGB(255,0,110)',
  'RGB(255,0,109)',
  'RGB(255,0,108)',
  'RGB(255,0,107)',
  'RGB(255,0,106)',
  'RGB(255,0,105)',
  'RGB(255,0,104)',
  'RGB(255,0,103)',
  'RGB(255,0,102)',
  'RGB(255,0,101)',
  'RGB(255,0,100)',
  'RGB(255,0,99)',
  'RGB(255,0,98)',
  'RGB(255,0,97)',
  'RGB(255,0,96)',
  'RGB(255,0,95)',
  'RGB(255,0,94)',
  'RGB(255,0,93)',
  'RGB(255,0,92)',
  'RGB(255,0,91)',
  'RGB(255,0,90)',
  'RGB(255,0,89)',
  'RGB(255,0,88)',
  'RGB(255,0,87)',
  'RGB(255,0,86)',
  'RGB(255,0,85)',
  'RGB(255,0,84)',
  'RGB(255,0,83)',
  'RGB(255,0,82)',
  'RGB(255,0,81)',
  'RGB(255,0,80)',
  'RGB(255,0,79)',
  'RGB(255,0,78)',
  'RGB(255,0,77)',
  'RGB(255,0,76)',
  'RGB(255,0,75)',
  'RGB(255,0,74)',
  'RGB(255,0,73)',
  'RGB(255,0,72)',
  'RGB(255,0,71)',
  'RGB(255,0,70)',
  'RGB(255,0,69)',
  'RGB(255,0,68)',
  'RGB(255,0,67)',
  'RGB(255,0,66)',
  'RGB(255,0,65)',
  'RGB(255,0,64)',
  'RGB(255,0,63)',
  'RGB(255,0,62)',
  'RGB(255,0,61)',
  'RGB(255,0,60)',
  'RGB(255,0,59)',
  'RGB(255,0,58)',
  'RGB(255,0,57)',
  'RGB(255,0,56)',
  'RGB(255,0,55)',
  'RGB(255,0,54)',
  'RGB(255,0,53)',
  'RGB(255,0,52)',
  'RGB(255,0,51)',
  'RGB(255,0,50)',
  'RGB(255,0,49)',
  'RGB(255,0,48)',
  'RGB(255,0,47)',
  'RGB(255,0,46)',
  'RGB(255,0,45)',
  'RGB(255,0,44)',
  'RGB(255,0,43)',
  'RGB(255,0,42)',
  'RGB(255,0,41)',
  'RGB(255,0,40)',
  'RGB(255,0,39)',
  'RGB(255,0,38)',
  'RGB(255,0,37)',
  'RGB(255,0,36)',
  'RGB(255,0,35)',
  'RGB(255,0,34)',
  'RGB(255,0,33)',
  'RGB(255,0,32)',
  'RGB(255,0,31)',
  'RGB(255,0,30)',
  'RGB(255,0,29)',
  'RGB(255,0,28)',
  'RGB(255,0,27)',
  'RGB(255,0,26)',
  'RGB(255,0,25)',
  'RGB(255,0,24)',
  'RGB(255,0,23)',
  'RGB(255,0,22)',
  'RGB(255,0,21)',
  'RGB(255,0,20)',
  'RGB(255,0,19)',
  'RGB(255,0,18)',
  'RGB(255,0,17)',
  'RGB(255,0,16)',
  'RGB(255,0,15)',
  'RGB(255,0,14)',
  'RGB(255,0,13)',
  'RGB(255,0,12)',
  'RGB(255,0,11)',
  'RGB(255,0,10)',
  'RGB(255,0,9)',
  'RGB(255,0,8)',
  'RGB(255,0,7)',
  'RGB(255,0,6)',
  'RGB(255,0,5)',
  'RGB(255,0,4)',
  'RGB(255,0,3)',
  'RGB(255,0,2)',
  'RGB(255,0,1)',
]

export default ColorWheelData

// Below is the code to generate above ColorWheelData

// // start of getting prizes of color wheel (all colors at the circle edge)
// let rgbValues = []
// if (isRCW && inputMethod === 'ColorWheel') {
//   const interpolateColor = (color1, color2, steps) => {
//     let result = []
//     for (let i = 0; i <= steps; i++) {
//       const ratio = i / steps
//       const r = Math.round(color1[0] * (1 - ratio) + color2[0] * ratio)
//       const g = Math.round(color1[1] * (1 - ratio) + color2[1] * ratio)
//       const b = Math.round(color1[2] * (1 - ratio) + color2[2] * ratio)

//       result.push(`RGB(${r},${g},${b})`)
//     }
//     return result
//   }

//   // Define key colors as [R, G, B]
//   const colors = [
//     [255, 0, 0], // Red
//     [255, 255, 0], // Yellow
//     [0, 255, 0], // Lime
//     [0, 255, 255], // Aqua
//     [0, 0, 255], // Blue
//     [255, 0, 255], // Magenta
//     [255, 0, 0], // Back to Red
//   ]

//   // 6 transitions between the colors (each transition generates 256 colors):
//   // Red → Yellow, Yellow → Lime, Lime → Aqua, Aqua → Blue, Blue → Magenta, Magenta → Red
//   // Generate all 1536 RGB color values (6 × 256 = 1536)
//   for (let i = 0; i < colors.length - 1; i++) {
//     rgbValues = rgbValues.concat(
//       interpolateColor(colors[i], colors[i + 1], 255),
//     )
//   }
// }

// // Remove duplicates from rgbValues, left 1530 RGB color values
// rgbValues = [...new Set(rgbValues)]

// console.log(rgbValues)
// // end of color wheel
